import ConfirmationDialog from '.'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const StreamConfigurationConfirmationDialog = ({
  onCloseDialog,
  onRequestSubmit,
  isVisible
}) => {
  const { t } = useTranslation()

  return (
    <ConfirmationDialog
      primaryButtonText={t('modal.configuration.primaryButton.title')}
      secondaryButtonText={t('modal.configuration.secondaryButton.title')}
      onRequestClose={onCloseDialog}
      onSecondarySubmit={onCloseDialog}
      onRequestSubmit={onRequestSubmit}
      modalLabel={t('modal.configuration.confirmStreamLabel')}
      modalHeading={t('modal.configuration.confirmStreamConfigHeading')}
      open={isVisible}
    />
  )
}
